import Vue from "vue";
import { $has } from "@Utils";
import { showVirtualKeyboardOnFocus } from "@/scripts/js/forgeService";

Vue.directive("has", {
  inserted: function (_, binding, vnode) {
    let { value, modifiers, arg } = binding;
    if (arg == "not") {
      if ($has(value, modifiers.any ? true : false)) {
        vnode.elm.parentElement.removeChild(vnode.elm);
      }
    } else {
      if (!$has(value, modifiers.any ? true : false)) {
        vnode.elm.parentElement.removeChild(vnode.elm);
      }
    }
  },
});

Vue.directive("virtual-keyboard", {
  bind: function (el) {
    // Check class name contains v-input for vuetify input components
    if (el.className.indexOf("v-input") !== -1) {
      // Get the input deep inside the element
      let input = el.querySelector("input");
      // Check if the input is found
      if (input === null) {
        // If not found, get the textarea deep inside the element
        input = el.querySelector("textarea");
      }
      if (input === null) return
      // Add the focus event listener to the input
      input.addEventListener("focus", showVirtualKeyboardOnFocus);
    } else {
      typeof el !== "undefined" &&
        typeof el.addEventListener === "function" &&
        el.addEventListener("focus", showVirtualKeyboardOnFocus);
    }
  },
});
